namespace SPA
{
	export namespace BRW
	{
		export namespace data
		{

			export class BRWTableDataReader
				extends ui.table.DataReader< Wollmilch.MP01.IObject >
			{
				public constructor()
				{
					super();
				}

				public GenerateDataField( BRWData: Wollmilch.MP01.IObject ): JQuery<HTMLElement>
				{
					const link = $(
						new Button(
							{
								title: BRWData.ObjectNumber,
								style: 'link',
								on:
								{
									click: () =>
									{
										app.getGlobalTabControl().addTab(
											BRWData.ObjectNumber,
											new SPA.BRW.Page( BRWData ),
											true,
										);
									},
								},
							},
						).getElement(),
					).removeClass( 'btn' );

					return new ui.base.BaseHTMLElement( 'tr' )
						.append( new ui.base.BaseHTMLElement( 'td' ).append( link ) )
						.append( new ui.base.BaseHTMLElement( 'td' )
							.append( BRWData.Object.Address ? BRWData.Object.Address.display : 'no data founded' ),
						)
						.append( new ui.base.BaseHTMLElement( 'td' ).append( new Date(BRWData.CreatedAt).pattern( 'd.m.Y H:i:s' ) ) )
					.Root();
				}
			}

		}
	}
}
